import { ROUTES } from "@app/constants";

export function getMyPricingProjectPath(
  briefId: string,
  userId: string
): string {
  const url = ROUTES.MY_PRICING_PROJECT.replace(":briefId", briefId);
  const params = new URLSearchParams({ userId });
  return `${url}?${params.toString()}`;
}

export function openMyPricingProject(briefId: string, userId: string): void {
  window.open(getMyPricingProjectPath(briefId, userId), "_blank");
}
